import React from "react";
import Typography from "components/Typography";
import { Radio } from "components/form";
import { StringItem } from "components/StringItem";
import { PROMO_TYPES } from "../../constants";
import classes from "./GoodsamInsuranceMobileTableThs.module.css";
import cn from 'classnames';

export const GoodsamInsuranceMobileTableThs = (props) => {
  const {
    planName,
    price,
    planId,
    isSelectedPlan,
    promo,
    promoType,
    onClick
  } = props;

  const { value: planNameValue } = planName;
  const { value: priceValue } = price;

  return (
    <div className={classes.container}>
      {promo ? (
        <div className={classes.promoContainer}
        >
          <div className={cn(
            classes.promoContainerInner,
            promoType === PROMO_TYPES.BEST_VALUE && classes.bestValue,
            promoType === PROMO_TYPES.PEACE_OF_MIND && classes.peaceOfMind
          )}>
            <StringItem
              data={promo}
              headerStyle={classes.promo}
              headerProps={{
                variant: "headline",
                size: "s",
                weight: "bold"
              }}
              textStyle={classes.promo}
              textProps={{
                variant: "headline",
                size: "s",
                weight: "bold"
              }}
            />
          </div>
        </div>
      ) : null}
      <div
        className={classes.column}
      >
        {planNameValue ? (
          <div className={classes.radioContainer} onClick={onClick}>
            <Radio
              id={planId}
              className={classes.radio}
              name={planNameValue}
              text={planNameValue}
              checked={isSelectedPlan}
              onChange={() => {}}
            />
          </div>
        ) : null}
      </div>
      <div className={classes.column}>
        {priceValue ? (
          <Typography
            variant="subtitle"
            size="s"
            className={classes.price}
          >
            ${priceValue}/day
          </Typography>
        ) : null}
      </div>
    </div>
  );
};
